module.exports = __webpack_public_path__ + "img/300_background.d182df96.png";